import { withFormik } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';

import BasicInput from './fields/BasicInput';

const InnerForm = (props) => {
  const { handleSubmit, isSubmitting, cancel } = props;

  return (
    <form className="m-login__form m-form" onSubmit={handleSubmit}>
      <BasicInput name="forgot_email" type="text" placeholder="Email" {...props} />

      <div className="m-login__form-action">
        <button
          id="m_login_forget_password_submit"
          className="btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air"
          disabled={isSubmitting}
        >
          Request Password Reset
        </button>
        <button
          type="button"
          id="m_login_forget_password_cancel"
          className="btn btn-outline-focus m-btn m-btn--pill m-btn--custom"
          onClick={cancel}
        >
          Cancel
        </button>
      </div>
    </form>
  );
};

InnerForm.propTypes = {
  handleSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
  cancel: PropTypes.func,
};

const ForgotPasswordForm = withFormik({
  mapPropsToValues: (props) => ({
    forgot_email: '',
  }),
  validate: (values, props) => {
    let errors = {};
    if (!values.forgot_email) {
      errors.forgot_email = 'Required';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.forgot_email)) {
      errors.forgot_email = 'Invalid email address';
    }
    return errors;
  },
  handleSubmit: (values, { props, resetForm }) => {
    props.onSubmit(values).then(() => resetForm());
  },
})(InnerForm);

export default ForgotPasswordForm;
